module.exports = __webpack_public_path__ + "img/map2.2372794c.png";